<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */
html,body,#app{
height: 100%;
margin: 0;
padding: 0
}
*{
  margin: 0;
}
h1 h2 h3{
 line-height: normal;
 margin: 0;
}
.el-submenu__icon-arrow{
	display: none; 

}
.el-icon-arrow-down::before {
  display: none; 
}
</style>



// WEBPACK FOOTER //
// src/App.vue